import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Button } from '../Button';
export const ExpandableText = (props)=>{
    const { text = '', bsStyle = 'link', btnClassName } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);
    useEffect(()=>{
        // Check if the text is overflowing
        const checkOverflow = ()=>{
            const current = textRef.current;
            if (current) {
                setIsOverflowing(current.scrollWidth > current.clientWidth || current.scrollHeight > current.clientHeight);
            }
        };
        checkOverflow();
        // Add a resize event listener to handle window changes
        window.addEventListener('resize', checkOverflow);
        // Clean up the event listener
        return ()=>window.removeEventListener('resize', checkOverflow);
    }, [
        text
    ]); // Dependency array includes text to re-check overflow if the text prop changes
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-100 mb-2 overflow-hidden",
        children: [
            !isExpanded && /*#__PURE__*/ _jsx("div", {
                className: "text-truncate",
                style: {
                    whiteSpace: 'pre-wrap',
                    maxHeight: '3em'
                },
                ref: textRef,
                children: text
            }),
            isExpanded && /*#__PURE__*/ _jsx("div", {
                className: "w-100",
                style: {
                    whiteSpace: 'pre-wrap'
                },
                children: text
            }),
            (isExpanded || isOverflowing) && /*#__PURE__*/ _jsx(Button, {
                className: classnames('text-nowrap', btnClassName),
                bsStyle: bsStyle,
                onClick: ()=>setIsExpanded((x)=>!x),
                children: isExpanded ? 'Visa mindre' : 'Visa mer'
            })
        ]
    });
};
